import React, { useEffect, useState, useRef } from 'react';
import { Icon } from '@iconify/react/dist/iconify.js';
//import { Link } from 'react-router-dom';
import api from '../../axiosConfig';
import Modal from 'bootstrap/js/dist/modal';
import AsyncSelect from 'react-select/async';
import Select from 'react-select';


export default function Tabla() {
    const [data, setData] = useState([]);
    const [total, setTotal] = useState(0);
    const [search, setSearch] = useState('');
    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(10);
    const [editingUser, setEditingUser] = useState(null);
    const [selectedEmpleado, setSelectedEmpleado] = useState(null);
    //const [roles, setRoles] = useState([]);
    const [habilitado, setHabilitado] = useState(editingUser?.habilitado ?? false);
    //const [selectedRoles, setSelectedRoles] = useState([]);

    const [selectedRoles, setSelectedRoles] = useState([]);
    const [rolesOptions, setRolesOptions] = useState([]);
    const [areasOptions, setAreasOptions] = useState([]);

    const [selectedAreas, setSelectedAreas] = useState([]);
    const [isRolDelegado, setIsRolDelegado] = useState(false);

    const rfcRef = useRef();
    const nombreRef = useRef();
    const curpRef = useRef();

    const [usuariosDefaultOptions, setUsuariosDefaultOptions] = useState([]);
    const [areasDefaultOptions, setAreasDefaultOptions] = useState([]);

    useEffect(() => {
        setHabilitado(editingUser?.habilitado ?? false);
    }, [editingUser]);

    const prefetchAreas = async () => {
        try {
            const opts = await loadAreas('');
            setAreasDefaultOptions(opts);
        } catch {
            setAreasDefaultOptions([]);
        }
    };

    const loadAreas = async (inputValue) => {
        try {
            const res = await api.get(`/empleados/areas/select2?cadena=${encodeURIComponent(inputValue || '')}&pagina=1`);
            return (res.data.results || []).map(emp => ({
                label: emp.text,
                value: emp.id,
                data: emp
            }));
        } catch (err) {
            console.error("Error al cargar areas:", err);
            return [];
        }
    };

    const prefetchUsuarios = async () => {
        try {
            const opts = await loadEmpleados('');
            setUsuariosDefaultOptions(opts);
        } catch {
            setUsuariosDefaultOptions([]);
        }
    };

    const loadEmpleados = async (inputValue) => {
        try {
            const res = await api.get(`/empleados/select2?cadena=${encodeURIComponent(inputValue || '')}&pagina=1`);
            return (res.data.results || []).map(emp => ({
                label: emp.text,
                value: emp.id,
                data: emp
            }));
        } catch (err) {
            console.error("Error al cargar empleados:", err);
            return [];
        }
    };

    const getRoles = async () => {

        setRolesOptions([{ label: "ADMINISTRADOR", value: 1 },
        { label: "TRABAJADOR", value: 2 },
        { label: "CONSULTA", value: 3 },
        { label: "DELEGADO", value: 4 }
        ]);

    };

    useEffect(() => {
        if (selectedRoles && selectedRoles.some(r => r.value === 4)) {
            setIsRolDelegado(true);
        } else {
            setIsRolDelegado(false);
        }
    }, [selectedRoles]);


    useEffect(() => {
        getDatos();
    }, [page, limit, search]);

    useEffect(() => {
        getRoles();
    }, []);

    const getDatos = async () => {
        try {
            const res = await api.get(
                `/usuarios/table?inicio=${(page - 1) * limit}&longitud=${limit}&orden=desc&ordenColumn=rfc&cadena=${search}`
            );
            setData(res.data.data);
            //setTotal(res.data.recordsTotal);
            setTotal(res.data.recordsFiltered);
        } catch (err) {
            console.error("Error al obtener datos:", err);
        }
    };

    const handleSearchChange = (e) => {
        setSearch(e.target.value);
        setPage(1);
    };

    const handleDelete = async (user) => {
        //setEditingUser(user);
        console.log(user)
        const confirmDelete = window.confirm(`¿Estás seguro que deseas eliminar al usuario "${user.rfc}"?`);

        if (confirmDelete) {
            await api.delete(`/usuarios/${user.idUsuario}`);

            getDatos();
        }

    };

    const handleEdit = (user) => {
        console.log("user", user)
        setEditingUser(user);
        setSelectedEmpleado({
            label: user.idEmpleado.nombre,
            value: user.idEmpleado.idEmpleado,
            data: user.idEmpleado
        });
        if (user.usuariosRolesList) {
            const mappedRoles = user.usuariosRolesList.map(rol => ({
                label: rol.idRol.nombre,
                value: rol.idRol.idRol
            }));
            setSelectedRoles(mappedRoles);
        } else {
            setSelectedRoles([]);
        }


        if (user.usuariosAreasList) {
            const mappedAreas = user.usuariosAreasList.map(rol => ({
                label: rol.cveArea,
                value: rol.cveArea
            }));
            setSelectedAreas(mappedAreas);
        } else {
            setSelectedAreas([]);
        }


        const modal = new Modal(document.getElementById('exampleModal'));
        modal.show();
    };

    const totalPages = Math.ceil(total / limit);

    const getValue = (key, fallback = '') => editingUser?.[key] ?? fallback;
    const getEmpleadoValue = (key, fallback = '') => editingUser?.idEmpleado?.[key] ?? fallback;

    const handleSubmit = async (e) => {
        e.preventDefault();
        const payload = {
            rfc: e.target.rfc.value,
            contrasenia: e.target.contrasenia.value || null,
            correoElectronico: e.target.correo.value,
            observaciones: e.target.observaciones.value,
            habilitado: habilitado,
            idEmpleado: {
                idEmpleado: selectedEmpleado?.value
            },
            usuariosRolesList: selectedRoles.map(role => ({
                idRol: {
                    idRol: role.value
                }
            })), usuariosAreasList: selectedAreas.map(role => ({
                cveArea: role.value
            }))
        };

        try {
            if (editingUser) {
                await api.put(`/usuarios/${editingUser.idUsuario}`, payload);
            } else {
                await api.post(`/usuarios`, payload);
            }
            getDatos();
            const modal = Modal.getInstance(document.getElementById('exampleModal'));
            modal.hide();

        } catch (err) {
            console.error("Error al guardar usuario:", err);
        }
    };


    const renderFooter = () => {
        return (
            <div className="d-flex align-items-center justify-content-between flex-wrap gap-2 mt-24">
                <span>Mostrando {data.length} de {total} Registros</span>
                <ul className="pagination d-flex flex-wrap align-items-center gap-2 justify-content-center">
                    {/* Botón anterior */}
                    <li className="page-item">
                        <button
                            className="page-link bg-neutral-200 text-secondary-light fw-semibold radius-8 border-0 d-flex align-items-center justify-content-center h-32-px w-32-px text-md"
                            onClick={() => page > 1 && setPage(page - 1)}
                            disabled={page === 1}
                        >
                            <Icon icon="ep:d-arrow-left" />
                        </button>
                    </li>

                    {/* Calcular rango de páginas */}
                    {(() => {
                        const pagesToShow = 5;
                        let startPage = Math.max(1, page - Math.floor(pagesToShow / 2));
                        let endPage = startPage + pagesToShow - 1;

                        if (endPage > totalPages) {
                            endPage = totalPages;
                            startPage = Math.max(1, endPage - pagesToShow + 1);
                        }

                        const pageNumbers = [];
                        for (let i = startPage; i <= endPage; i++) {
                            pageNumbers.push(i);
                        }

                        return pageNumbers.map((num) => (
                            <li className="page-item" key={num}>
                                <button
                                    className={`page-link fw-semibold radius-8 border-0 d-flex align-items-center justify-content-center h-32-px w-32-px text-md ${page === num
                                        ? "bg-primary-600 text-white"
                                        : "bg-neutral-200 text-secondary-light"
                                        }`}
                                    onClick={() => setPage(num)}
                                >
                                    {num}
                                </button>
                            </li>
                        ));
                    })()}

                    {/* Botón siguiente */}
                    <li className="page-item">
                        <button
                            className="page-link bg-neutral-200 text-secondary-light fw-semibold radius-8 border-0 d-flex align-items-center justify-content-center h-32-px w-32-px text-md"
                            onClick={() => page < totalPages && setPage(page + 1)}
                            disabled={page === totalPages}
                        >
                            <Icon icon="ep:d-arrow-right" />
                        </button>
                    </li>
                </ul>
            </div>
        )
    }


    return (
        <>
            <div className="card h-100 p-0 radius-12">
                <div className="card-header border-bottom bg-base py-16 px-24 d-flex align-items-center flex-wrap gap-3 justify-content-between">
                    <div className="d-flex align-items-center flex-wrap gap-3">
                        <span className="text-md fw-medium text-secondary-light mb-0">Mostrar</span>
                        <select
                            className="form-select form-select-sm w-auto ps-12 py-6 radius-12 h-40-px"
                            value={limit}
                            onChange={(e) => setLimit(parseInt(e.target.value))}
                        >
                            <option value={10}>10</option>
                            <option value={20}>20</option>
                            <option value={50}>50</option>
                        </select>
                        <form className="navbar-search">
                            <input
                                type="text"
                                className="bg-neutra h-40-px w-auto"
                                name="search"
                                placeholder="Buscar"
                                value={search}
                                onChange={handleSearchChange}
                            />
                            <Icon icon="ion:search-outline" className="icon" />
                        </form>
                    </div>
                    <button
                        type="button"
                        className="btn btn-primary-600 text-sm btn-sm px-12 py-12 radius-8 d-flex align-items-center gap-2"

                        onClick={() => {
                            setEditingUser(null)
                            const modal = new Modal(document.getElementById('exampleModal'));
                            modal.show();
                        }}
                    >
                        <Icon icon="ic:baseline-plus" className="icon text-xl line-height-1" />
                        Nuevo Usuario
                    </button>
                </div>
                <div className="card-body p-24">
                    <div className="table-responsive scroll-sm">
                        <table className="table bordered-table sm-table mb-0">
                            <thead>
                                <tr>
                                    <th scope="col">Id</th>
                                    <th scope="col">RFC</th>
                                    <th scope="col">Nombre</th>
                                    <th scope="col">No. Empleado</th>
                                    <th scope="col" className="text-center">Estatus</th>
                                    <th scope="col" className="text-center">Acciones</th>
                                </tr>
                            </thead>
                            <tbody>
                                {data.map((e) => (
                                    <tr key={e.idUsuario}>
                                        <td>{e.idUsuario}</td>
                                        <td>{e.rfc}</td>
                                        <td>{e.idEmpleado?.nombre}</td>
                                        <td>{e.idEmpleado?.noEmpleado}</td>
                                        <td className="text-center">
                                            <span className="bg-success-focus text-success-600 border border-success-main px-24 py-4 radius-4 fw-medium text-sm">
                                                {e.idEmpleado?.estatus}
                                            </span>
                                        </td>
                                        <td className="text-center">
                                            <div className="d-flex align-items-center gap-10 justify-content-center">
                                                <button
                                                    type="button"
                                                    className="bg-success-focus text-success-600 bg-hover-success-200 fw-medium w-40-px h-40-px d-flex justify-content-center align-items-center rounded-circle"
                                                    onClick={() => handleEdit(e)}
                                                >
                                                    <Icon icon="lucide:edit" className="menu-icon" />
                                                </button>
                                                {/*<button
                                                    type="button"
                                                    className="bg-danger-focus text-danger-600 bg-hover-danger-200 fw-medium w-40-px h-40-px d-flex justify-content-center align-items-center rounded-circle"
                                                    onClick={() => handleDelete(e)}
                                                >
                                                    <Icon icon="lucide:trash" className="menu-icon" />
                                                </button>*/}

                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>

                    {renderFooter()}


                </div>
            </div>


            {/* Modal */}
            <div className="modal fade" id="exampleModal" tabIndex={-1} aria-hidden="true">
                <div className="modal-dialog modal-lg modal-dialog-centered">
                    <div className="modal-content radius-16 bg-base">
                        <div className="modal-header py-16 px-24 border-bottom">
                            <h5 className="modal-title">
                                {editingUser ? 'Editar Usuario' : 'Nuevo Usuario'}
                            </h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
                        </div>
                        <div className="modal-body p-24">
                            <form onSubmit={handleSubmit}>
                                <div className="row">



                                    <div className="col-6 mb-20">
                                        <label className="form-label">No. Empleado</label>
                                        <AsyncSelect
                                            required
                                            cacheOptions
                                            defaultOptions={usuariosDefaultOptions}
                                            onMenuOpen={prefetchUsuarios}             // 🔎 buscar al click
                                            loadOptions={loadEmpleados}
                                            onChange={(selected) => {
                                                const empleado = selected?.data?.data;
                                                console.log("rfc", empleado.rfc)
                                                console.log("curp", empleado.curp)
                                                console.log("nombre", empleado.nombre)
                                                if (rfcRef.current) {
                                                    rfcRef.current.value = empleado.rfc;
                                                }

                                                if (curpRef.current) {
                                                    curpRef.current.value = empleado.curp;
                                                }

                                                if (nombreRef.current) {
                                                    nombreRef.current.value = empleado.nombre;
                                                }

                                                setSelectedEmpleado(selected); // Solo el ID o número de empleado
                                            }}
                                            placeholder="Buscar empleado..."
                                            value={selectedEmpleado}
                                        />
                                    </div>

                                    <div className="col-6 mb-20">
                                        <label className="form-label">Contraseña</label>
                                        <input type="text" name="contrasenia" className="form-control" required={!editingUser} />
                                    </div>

                                    <div className="col-6 mb-20">
                                        <label className="form-label">RFC</label>
                                        <input type="text" name="rfc" ref={rfcRef} className="form-control" defaultValue={getEmpleadoValue('rfc')} disabled />
                                    </div>

                                    <div className="col-6 mb-20">
                                        <label className="form-label">CURP</label>
                                        <input type="text" name="curp" ref={curpRef} className="form-control" defaultValue={getEmpleadoValue('curp')} disabled />
                                    </div>

                                    <div className="col-12 mb-20">
                                        <label className="form-label">Nombre</label>
                                        <input type="text" name="nombre" ref={nombreRef} className="form-control" defaultValue={getEmpleadoValue('nombre')} disabled />
                                    </div>


                                    <div className="col-6 mb-20">
                                        <label className="form-label">Correo Electrónico *</label>
                                        <input type="email" name="correo" required className="form-control" defaultValue={getValue('correoElectronico')} />
                                    </div>
                                    <div className="col-6 mb-20">
                                        <label className="form-label">Observaciones</label>
                                        {/* <input type="text" name="observaciones" className="form-control" defaultValue={editingUser?.observaciones} />*/}
                                                                                <input
                                            type="text"
                                            name="observaciones"
                                            className="form-control"
                                            value={editingUser?.observaciones}
                                            onChange={(e) => setEditingUser(prev => ({ ...prev, observaciones: e.target.value }))}
                                        />
                                    </div>
                                    <div className="col-12 d-flex align-items-center gap-2 mb-20">
                                        {/*<input type="checkbox" name="habilitado" className="form-check-input" defaultChecked={editingUser?.habilitado ?? true} /> */}
                                        <input type="checkbox" name="habilitado" className="form-check-input" checked={habilitado} onChange={e => setHabilitado(e.target.checked)} />
                                        <label className="form-check-label">Habilitado</label>
                                    </div>
                                    <div className="col-12 mb-20">
                                        <label className="form-label">Roles</label>
                                        <Select
                                            isMulti
                                            name="roles"
                                            options={rolesOptions} // esto es un array de objetos { label, value }
                                            value={selectedRoles}
                                            onChange={(selected) => setSelectedRoles(selected)}
                                            className="basic-multi-select"
                                            classNamePrefix="select"
                                            placeholder="Selecciona roles..."
                                        />
                                    </div>


                                    {isRolDelegado &&
                                        <div className="col-12 mb-20">
                                            <label className="form-label">Areas</label>
                                            <AsyncSelect
                                                required
                                                isMulti
                                                cacheOptions
                                                defaultOptions={areasDefaultOptions}
                                                onMenuOpen={prefetchAreas}             // 🔎 buscar al click
                                                loadOptions={loadAreas}
                                                onChange={(selected) => setSelectedAreas(selected)}
                                                placeholder="Buscar empleado..."
                                                value={selectedAreas}
                                            />
                                        </div>}

                                </div>
                                <div className="text-center mt-24">
                                    <button type="submit" className="btn btn-primary px-48 py-12">
                                        Guardar
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>

        </>
    );
}